import React from "react";
import { Modal as BootstrapModal } from "react-bootstrap";
import { nanoid } from "nanoid";
import "../Style/Modal.css";
import { X } from "react-feather";

const Modal = ({
  children,
  headerText = null,
  onClose,
  visible = false,
  size,
  centered = false,
  style,
}) => {
  const id = nanoid();

  return (
    <BootstrapModal
      size={size}
      show={visible}
      onHide={onClose}
      aria-labelledby={id}
      centered={centered}
      style={style}
      dialogClassName="custom-modal"
    >
      <BootstrapModal.Header>
        <BootstrapModal.Title id={id}>{headerText}</BootstrapModal.Title>
        <button
          type="button"
          className="btn-tool"
          aria-label="Close"
          onClick={onClose}
        >
          {/* <i className="fa-solid fa-xmark"></i> */}
          <X />
        </button>
      </BootstrapModal.Header>
      <BootstrapModal.Body
        style={{ maxHeight: "70vh", overflow: "auto" }}
        className="modal-body-scrollbar"
      >
        {children}
      </BootstrapModal.Body>
    </BootstrapModal>
  );
};

export default Modal;
